import React from 'react';
import './index.css';
import { createRoot, hydrateRoot } from 'react-dom/client';
// Fix: Corrected import path for App component. The error "is not a module" is resolved by ensuring App.tsx exports a component.
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
